export type ColorFamily =
  | 'red'
  | 'gray'
  | 'blue'
  | 'green'
  | 'gold'
  | 'amber'
  | 'teal'
  | 'indigo'
  | 'maroon';

export const colors = {
  red: {
    50: '#FFF1F0',
    100: '#FFDFDB',
    200: '#FEC3BD',
    300: '#F6978D',
    400: '#ED6A5F',
    500: '#E83F34',
    600: '#CB2E1E',
    700: '#AC2314',
    800: '#942116',
    900: '#7A2018',
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },
  blue: {
    50: '#EEF6FC',
    100: '#D0EAFB',
    200: '#AEDAF6',
    300: '#89C5EE',
    400: '#6BB1E1',
    500: '#4F99CD',
    600: '#3D7CAC',
    700: '#2B6087',
    800: '#204865',
    900: '#152E40',
  },
  green: {
    50: '#ECFDF5',
    100: '#D1FAE5',
    200: '#A7F3D0',
    300: '#6EE7B7',
    400: '#34D399',
    500: '#10B981',
    600: '#059669',
    700: '#047857',
    800: '#065F46',
    900: '#064E3B',
  },
  gold: {
    50: '#FBF9F4',
    100: '#FDF4E0',
    200: '#F9E4B9',
    300: '#F2D497',
    400: '#DDB96E',
    500: '#BB9446',
    600: '#9C7C3C',
    700: '#7C612E',
    800: '#624E25',
    900: '#45371D',
  },
  amber: {
    50: '#FDFAF2',
    100: '#FAF0CE',
    200: '#F5D989',
    300: '#EDBC47',
    400: '#DE9B18',
    500: '#BC7B0A',
    600: '#975F08',
    700: '#724509',
    800: '#4F3008',
    900: '#301D05',
  },
  teal: {
    50: '#F0FAFA',
    100: '#CCEEEE',
    200: '#96D8D8',
    300: '#53BCBC',
    400: '#239D9D',
    500: '#0E7D7D',
    600: '#0A6363',
    700: '#084D4D',
    800: '#053838',
    900: '#032525',
  },
  indigo: {
    50: '#F4F4FB',
    100: '#E2E3F5',
    200: '#C2C4EA',
    300: '#9698D8',
    400: '#6E70C4',
    500: '#5052A8',
    600: '#3C3E88',
    700: '#2C2E68',
    800: '#1E1F4A',
    900: '#12132E',
  },
  maroon: {
    50: '#FEF7F8',
    100: '#FADDE2',
    200: '#F0B4BC',
    300: '#E08490',
    400: '#CC5767',
    500: '#AE3347',
    600: '#8F2438',
    700: '#711B2C',
    800: '#531422',
    900: '#360D16',
  },
  text: {
    primary: '#171a1c',
    secondary: '#32383e',
    tertiary: '#4B5563',
    icon: '#636b74',
  },
  common: {
    white: '#FFFFFF',
    black: '#000000',
  },
} as const;
